import { updateKeyInStore } from 'App';
import * as Yup from 'yup';

import { requiredFiles } from '../../useValidateQuestionnaire';
import { BusinessTypeStateValues, updateKey } from './slice';

export const businessTypes = [
  {
    label: 'C Corporation',
    value: 'C Corporation',
  },
  {
    label: 'S Corporation',
    value: 'S Corporation',
  },
  {
    label: 'LLC taxed as Sole Propreitorship',
    value: 'LLC taxed as Sole Propreitorship',
  },
  {
    label: 'LLC taxed as C Corporation',
    value: 'LLC taxed as C Corporation',
  },
  {
    label: 'LLC taxed as S Corporation',
    value: 'LLC taxed as S Corporation',
  },
  {
    label: 'LLC taxed as Partnership',
    value: 'LLC taxed as Partnership',
  },
  {
    label: 'Partnership',
    value: 'Partnership',
  },
  {
    label: 'Sole Propreitorship',
    value: 'Sole Propreitorship',
  },
  {
    label: 'Non-Profit',
    value: 'Non-Profit',
  },
  {
    label: 'Trust',
    value: 'Trust',
  },
];

export const fields: IBaseField<keyof BusinessTypeStateValues>[] = [
  {
    name: 'businessType',
    label: 'Business Type',
    type: 'select',
    options: businessTypes,
    effect: updateKeyInStore(updateKey),
    comment: true,
    dependencies: [
      {
        name: 'doYouHaveCopyOfYourIrsSCorpApprovalLetter',
        label: 'Do you have copy of your IRS S Corp Approval Letter?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        comment: true,
        predicate: (v) => v === 'S Corporation',
        dependencies: [
          {
            name: 'pleaseUploadACopyOfIrsSCorpApprovalLetter',
            label: 'Please upload a copy of IRS S Corp Approval Letter.',
            type: 'upload',
            effect: updateKeyInStore(updateKey),
            predicate: (v) => v === 'yes',
            comment: true,
          },
        ],
      },

      {
        name: 'theTaxReturnForAnLlcTaxedAsASoleProprietorshipIsFiledAsAScheduleCWithYourPersonalReturnPleaseBeAdvisedThatIfWeArePreparingYourScheduleCAndPersonalIncomeTaxReturnThisPortionWillNotBePreparedUntilYouHaveSubmittedBothYourBusinessTaxInformationAndYourPersonalTaxInformation',
        label: () =>
          'The tax return for an LLC taxed as a Sole Proprietorship is filed as a Schedule C with your personal return. Please be advised that if we are preparing your Schedule C and personal income tax return, this portion will not be prepared until you have submitted both your Business Tax Information and your Personal Tax Information.',
        type: 'information',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'Sole Propreitorship',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
